import { WhiteSpaceGroup, WhiteSpaceStatus } from 'enums';

import mainTheme from './main';
import { makeWhiteSpaceLegendTheme } from './utils';

const whiteSpacePalette = {
  [WhiteSpaceGroup.AGREEMENT_TYPE]: {
    groupHeader: 'rgb(166, 186, 218)', // HSLUV_2
    columnHeader: 'rgb(184, 200, 225)', // HSLUV_3
    cell: '#fff', // HSLUV_6
    [WhiteSpaceStatus.ACTIVE]: 'rgb(115, 218, 256)', // HSV_6
    [WhiteSpaceStatus.PROSPECT]: 'rgb(109, 204, 92)', // HSV_4
    [WhiteSpaceStatus.ANNOTATED]: 'rgba(210, 210, 210)',
    [WhiteSpaceStatus.OPEN_OPPORTUNITY]: '#f4cccc',
  },
  [WhiteSpaceGroup.PRODUCT_SUBCATEGORY]: {
    groupHeader: 'rgb(222, 175, 151)',
    columnHeader: 'rgb(228, 191, 174)',
    cell: '#fff',
    [WhiteSpaceStatus.ACTIVE]: 'rgb(115, 218, 256)', // HSV_6
    [WhiteSpaceStatus.PROSPECT]: 'rgb(109, 204, 92)', // HSV_4
    [WhiteSpaceStatus.ANNOTATED]: 'rgba(210, 210, 210)',
    [WhiteSpaceStatus.OPEN_OPPORTUNITY]: '#f4cccc',
  },

  [WhiteSpaceGroup.INVOICED_PRODUCT]: {
    groupHeader: 'rgb(202, 184, 136)',
    columnHeader: 'rgb(216, 197, 146)',
    cell: '#fff',
    [WhiteSpaceStatus.ACTIVE]: 'rgb(115, 218, 256)', // HSV_6
    [WhiteSpaceStatus.PROSPECT]: 'rgb(109, 204, 92)', // HSV_4
    [WhiteSpaceStatus.ANNOTATED]: 'rgba(210, 210, 210)',
    [WhiteSpaceStatus.OPEN_OPPORTUNITY]: '#f4cccc',
  },
};

const whitespace = {
  palette: whiteSpacePalette,
  legend: makeWhiteSpaceLegendTheme(whiteSpacePalette),
};

const theme = {
  ...mainTheme,
  whitespace,
};

export default theme;
